import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Receipt, LogOut, CreditCard, Bot } from 'lucide-react';
import GlassPanel from '../../components/GlassPanel';
import EmptyState from '../../components/EmptyState';
import { AIBadge } from '../../components/AIComponents';

const clientSubNav = [
  { path: '/client', label: 'Dashboard' },
  { path: '/client/quotes', label: 'Quotes' },
  { path: '/client/invoices', label: 'Invoices' },
];

const mockInvoices = [
  { id: 1045, title: 'Kitchen Refit - Final Payment', amount: 5100, status: 'pending', date: '2024-01-15', dueDate: '2024-01-29' },
  { id: 1040, title: 'Initial Deposit', amount: 4250, status: 'paid', date: '2024-01-08', paidDate: '2024-01-09' },
];

// Client AI Help Component
function ClientAIHelp() {
  return (
    <div className="client-ai-help">
      <div className="client-ai-help-icon">
        <Bot size={20} />
      </div>
      <div className="client-ai-help-content">
        <h4>Need help understanding this?</h4>
        <p>AI explains only. It cannot accept or change anything.</p>
      </div>
      <button disabled title="AI explains only. It cannot accept or change anything.">
        Ask AI to explain
      </button>
    </div>
  );
}

export function ClientInvoices() {
  const location = useLocation();

  return (
    <div className="client-portal">
      <header className="client-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-md)' }}>
          <h1 style={{ fontFamily: 'var(--font-family-display)', fontSize: '1.25rem', fontWeight: '700' }}>
            Trade<span style={{ color: 'var(--accent-primary)' }}>Life</span>
          </h1>
          <span style={{ color: 'var(--text-muted)', fontSize: '0.875rem' }}>Client Portal</span>
        </div>
        <button className="btn btn-ghost btn-icon" style={{ color: 'var(--text-muted)' }}>
          <LogOut size={18} />
        </button>
      </header>

      <div className="client-content">
        <div className="client-nav">
          {clientSubNav.map((item) => (
            <Link key={item.path} to={item.path} className={`client-nav-link ${location.pathname === item.path ? 'active' : ''}`}>
              {item.label}
            </Link>
          ))}
        </div>

        <h2 style={{ fontSize: '1.5rem', fontWeight: '600', color: 'var(--text-primary)', marginBottom: 'var(--space-lg)' }}>
          Your Invoices
        </h2>

        <GlassPanel title="All Invoices" titleIcon={Receipt}>
          {mockInvoices.length > 0 ? (
            <div className="list-container">
              {mockInvoices.map((invoice) => (
                <div key={invoice.id} className="glass-panel" style={{ marginBottom: 'var(--space-md)', cursor: 'default' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'var(--space-md)' }}>
                    <div>
                      <h3 style={{ fontSize: '1rem', fontWeight: '600', color: 'var(--text-primary)', display: 'flex', alignItems: 'center', gap: 'var(--space-sm)' }}>
                        Invoice #{invoice.id}
                        <AIBadge text="AI Help" />
                      </h3>
                      <p style={{ fontSize: '0.875rem', color: 'var(--text-muted)' }}>{invoice.title}</p>
                    </div>
                    <span className={`status-badge ${invoice.status === 'paid' ? 'paid' : 'pending'}`}>
                      {invoice.status}
                    </span>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ display: 'flex', gap: 'var(--space-lg)' }}>
                      <div>
                        <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>Date</div>
                        <div style={{ fontSize: '0.875rem', color: 'var(--text-secondary)' }}>{invoice.date}</div>
                      </div>
                      {invoice.status === 'pending' ? (
                        <div>
                          <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>Due Date</div>
                          <div style={{ fontSize: '0.875rem', color: 'var(--status-warning)' }}>{invoice.dueDate}</div>
                        </div>
                      ) : (
                        <div>
                          <div style={{ fontSize: '0.75rem', color: 'var(--text-muted)' }}>Paid</div>
                          <div style={{ fontSize: '0.875rem', color: 'var(--status-success)' }}>{invoice.paidDate}</div>
                        </div>
                      )}
                    </div>
                    <div style={{ fontSize: '1.25rem', fontWeight: '700', color: invoice.status === 'paid' ? 'var(--status-success)' : 'var(--status-warning)' }}>
                      £{invoice.amount.toLocaleString()}
                    </div>
                  </div>
                  {invoice.status === 'pending' && (
                    <div style={{ marginTop: 'var(--space-lg)', paddingTop: 'var(--space-md)', borderTop: '1px solid var(--glass-border)' }}>
                      <button className="btn btn-primary w-full" disabled>
                        <CreditCard size={16} />Pay Now
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <EmptyState icon={Receipt} title="No invoices" description="You don't have any invoices yet" />
          )}
        </GlassPanel>

        {/* Client AI Help */}
        <ClientAIHelp />
      </div>
    </div>
  );
}

export default ClientInvoices;
